import React, {useState, useEffect} from 'react';
import {
    Container,
    Button,
    Menu,
    Form,
    Grid,
    GridColumn,
    List,
    ListItem,
    Image,
    Icon,
    Segment,
    Header,
    GridRow
} from 'semantic-ui-react'

import withRouter from "../common/withRouter";
import * as Yup from "yup";
import {useFormik, setNestedObjectValues} from "formik";


const ClinicianForm = (props) => {

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {},
        validationSchema: Yup.object().shape({}),
        onSubmit: (values) => {
            props.router.navigate('/')
        }
    });

    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const phonify = (text) => {
        var urlRegex = /(?:[-+() ]*\d){10,13}/gm;
        return text.replace(urlRegex, function (url) {
            return '<a href="tel:+' + url + '">' + url + '</a>';
        })
    }
    const urlify = (text) => {
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function (url) {
            return '<a target="_blank" href="' + url + '">' + url + '</a>';
        })
    }
    const isMobile = width <= 768;

    let learnMore = phonify("Learn more about safer use practices at SaferSubstanceUse.com. ")
    learnMore = urlify(learnMore)

    let visit = phonify("Visit the CHCV Syringe Services Program at 270 Congress Avenue on Monday, Wednesday and Friday from 9 am to 12 pm and 1 pm to 4 pm or call (203) 823-0743 for mobile clinic dates and locations.")
    visit = urlify(visit)

    let neverUse = phonify("Never Use Alone: If you are alone, call the Never Use Alone line (877-696-1996) or use another monitoring app/strategy to alert others to unresponsiveness.")
    learnMore = urlify(learnMore)

    let imageWidth = (width + (isMobile ? 150 : -50)) / 4
    imageWidth = imageWidth > 250 ? 250 : imageWidth
    return (
        <React.Fragment>
            <Menu fixed='top' inverted
                  style={{background: "linear-gradient(90deg, rgba(11,89,223,1) 0%, rgba(24,122,229,1) 49%, rgba(68,225,249,1) 100%)"}}>
            </Menu>
            <Container style={{marginTop: '3em', alignContent: "center"}}>
                <Grid reversed='computer' doubling columns={2}
                      style={{padding: 20, alignContent: "center"}}>
                    <GridColumn width={4} style={{
                        padding: 0,
                        paddingTop: 5,
                        alignContent: "center",
                        textAlign: isMobile ? "center" : "initial"
                    }}>
                        <Button className={'menu_button'}
                                icon
                                labelPosition='left'
                                onClick={() => {
                                    window.open("https://clinician.adapt4change.org/", "_self")
                                }}>
                            <Icon name='list alternate' size={"large"}/>
                            Clinician Form</Button>
                    </GridColumn>
                    <GridColumn width={12} style={{
                        padding: 0,
                        paddingTop: 15,
                        textAlign: isMobile ? "center" : "initial"
                    }}>
                        <Header as={'h4'} style={{cursor: "pointer"}} onClick={() => {
                            window.open("https://www.adapt4change.org/", "_self")
                        }}>
                            <span style={{color: "#0959DF"}}
                            >ADAPT4</span>Change
                        </Header>
                    </GridColumn>

                </Grid>
            </Container>
            <Menu inverted
                  style={{backgroundColor: "#1E3766", paddingBottom: 50, paddingTop: 50}}>
                <Container style={{display: "flex", flexDirection: "column"}}>
                    <div style={{display: "flex", flexDirection: "row", marginBottom: 0}}>
                        <Image className={"image-shadow"} src={process.env.PUBLIC_URL + '/image1.png'}
                               style={{
                                   width: imageWidth, transform: "rotate(-10deg)",
                                   height: imageWidth,
                                   objectFit: 'cover',
                                   marginLeft: isMobile ? -10 : 50
                               }}/>
                        <Image className={"image-shadow"} src={process.env.PUBLIC_URL + '/image2.png'}
                               style={{
                                   width: imageWidth, transform: "rotate(5deg)",
                                   height: imageWidth,
                                   objectFit: 'cover',
                                   marginLeft: -15,
                                   marginTop: 15
                               }}/>
                        <Image className={"image-shadow"} src={process.env.PUBLIC_URL + '/image3.png'}
                               style={{
                                   width: imageWidth, transform: "rotate(-5deg)",
                                   height: imageWidth,
                                   objectFit: 'cover',
                                   marginLeft: -40
                               }}/>
                        <Image className={"image-shadow"} src={process.env.PUBLIC_URL + '/image4.png'}
                               style={{
                                   width: imageWidth, transform: "rotate(10deg)",
                                   height: imageWidth,
                                   objectFit: 'cover',
                                   marginLeft: -30,
                                   marginTop: 35
                               }}/>
                    </div>
                    <Header as={'h4'} style={{
                        textAlign: "center",
                        color: "white",
                        letterSpacing: 2.5,
                        fontFamily: "Rockwell",
                        fontWeight: 400,
                        fontSize: isMobile ? 28 : 40
                    }}>
                        Feel like yourself again.
                    </Header>
                </Container>
            </Menu>
            <Container>
                <div style={{
                    marginBottom: '3em',
                    marginLeft: '3vw',
                    marginRight: "3vw",
                    borderRadius: 20,
                    padding: isMobile ? 1 : 40,
                    backgroundColor: "white"
                }}>
                    <span>This project helps people with opioid use disorder (OUD) get treatment in the emergency department and connect to community programs.
                        Medicines like Suboxone (Buprenorphine) and methadone can ease cravings and withdrawal, while local clinics provide support for recovery and safety.</span>
                    <br/>
                    <br/>
                    <br/>
                    <div
                        style={{
                            whiteSpace: "pre-wrap",
                            fontSize: 16,
                            textAlign: "center"
                        }}>
                        <Grid doubling columns={2}>
                            <GridColumn width={8} style={{alignContent: "center"}}>
                                <iframe style={{alignContent: "center", width: "100%", height: "100%", minHeight: 230}}
                                        src={"https://www.youtube.com/embed/rdJAYzE01eI"}>
                                </iframe>

                            </GridColumn>
                            <GridColumn width={8} style={{alignContent: "center"}}>
                                <div
                                    style={{
                                        whiteSpace: "pre-wrap",
                                        fontSize: 16,
                                        textAlign: "left"
                                    }}>

                                    <Header as={'h4'} style={{textAlign: isMobile? "center": "left", color: "#053b99"}}>
                                        What is Suboxone?
                                    </Header>
                                    <span>Suboxone is a medication used to treat opioid use disorder.</span>
                                    <List as='ul' className={"dashed"}>
                                        <ListItem as='li'><span>Reduces drug cravings</span>
                                        </ListItem>
                                        <ListItem as='li'>
                                            <span>Helps prevent withdrawal symptoms</span>
                                        </ListItem>
                                        <ListItem as='li'><span>Blocks the effects of opioids, but opioids are still effective for pain</span>
                                        </ListItem>
                                        <ListItem as='li'><span>Significantly reduces the risk of overdose </span>
                                        </ListItem>
                                        <ListItem as='li'><span>Helps people out of the cycle of addiction and withdrawal so they can focus on recovery</span>
                                        </ListItem>
                                    </List>
                                </div>
                            </GridColumn>
                        </Grid>
                    </div>
                </div>
                <div style={{
                    marginBottom: '3em',
                    marginLeft: '3vw',
                    marginRight: "3vw",
                    borderRadius: 20,
                    padding: isMobile ? 1 : 40,
                    backgroundColor: "white"
                }}>
                    <div
                        style={{
                            whiteSpace: "pre-wrap",
                            fontSize: 16,
                            textAlign: "center"
                        }}>
                        <Grid doubling columns={2}>
                            <GridColumn width={8} style={{alignContent: "center"}}>
                                <div
                                    style={{
                                        whiteSpace: "pre-wrap",
                                        fontSize: 16,
                                        textAlign: "left"
                                    }}>
                                    <Header as={'h4'} style={{textAlign: "center", color: "#0A8453"}}>
                                        <Grid doubling={isMobile} columns={2} centered>
                                            <GridColumn width={3}
                                                        style={{
                                                            alignContent: "center",
                                                            textAlign: isMobile ? "center" : "right"
                                                        }}>
                                                <Image src={process.env.PUBLIC_URL + '/home.png'} style={{
                                                    width: 60,
                                                    height: 55,
                                                    marginLeft: isMobile ? "auto" : "none",
                                                    marginRight: isMobile ? "auto" : "none",
                                                    border: "1px solid #0A8453",
                                                    borderRadius: 15,
                                                    backgroundColor: "white",
                                                    padding: "5px 5px"
                                                }}/>
                                            </GridColumn>
                                            <GridColumn width={12}
                                                        style={{
                                                            alignContent: isMobile ? "center": "left",
                                                            textAlign: isMobile ? "center" : "left"
                                                        }}>
                                                New Haven Resources
                                            </GridColumn>
                                        </Grid>
                                    </Header>
                                    <span>If you are struggling with opioid use, you are not alone. Help is available.
                                            There are a variety of resources dedicated to supporting individuals with opioid use disorder. Whether you’re seeking treatment, counseling, or community support, there are options.
                                            Clinicians at YNHH can help identify resources that align with your needs.</span>
                                    <br/>
                                    <br/>
                                    <div className={"button_wrapper"}><Button
                                        fluid
                                        className={"resource_button"}
                                        onClick={() => {
                                            window.open(process.env.PUBLIC_URL + "/resources", "_self")
                                        }}
                                    >View Full List of Resources
                                    </Button></div>
                                </div>
                            </GridColumn>
                            <GridColumn width={8}>
                                <Image src={process.env.PUBLIC_URL + '/image5.png'}/>
                            </GridColumn>

                        </Grid>
                    </div>
                </div>
                <hr/>
                <div style={{
                    marginBottom: '3em',
                    marginLeft: '3vw',
                    marginRight: "3vw",
                    borderRadius: 20,
                    padding: isMobile ? 1 : 40,
                    backgroundColor: "white"
                }}>
                    <Header as={'h4'} style={{textAlign: "center", color: "#580272"}}>
                        <Grid doubling={isMobile} columns={2} centered>
                            <GridColumn width={6} style={{
                                alignContent: "center",
                                textAlign: isMobile ? "center" : "right"
                            }}>
                                <Image src={process.env.PUBLIC_URL + '/cross.png'} style={{
                                    width: 60,
                                    height: 55,
                                    marginLeft: "auto",
                                    marginRight: isMobile ? "auto" : "0",
                                    border: "1px solid #691A81",
                                    borderRadius: 10,
                                    backgroundColor: "white",
                                    padding: "5px 5px"
                                }}/>
                            </GridColumn>
                            <GridColumn width={10} style={{
                                alignContent: "center",
                                textAlign: isMobile ? "center" : "left"
                            }}>
                                Safer Use Saves Lives
                            </GridColumn>
                        </Grid>
                    </Header>
                    <span
                        dangerouslySetInnerHTML={{__html: neverUse}}></span>
                    <br/>
                    <br/>
                    <div
                        style={{
                            marginTop: 20,
                            marginBottom: 10,
                            whiteSpace: "pre-wrap",
                            fontSize: 16,
                            textAlign: "center"
                        }}>
                        <Grid doubling columns={2}>
                            <GridColumn width={8} style={{padding: 0}}>
                                <List as='ul'>
                                    <ListItem as='div' style={{marginBottom: 20}}><p
                                        style={{textAlign: "left"}}><span>
                                            <strong>Stay Informed: </strong>Know the risks associated with drug use and learn ways to minimize them.
                                        </span></p>
                                    </ListItem>
                                    <ListItem as='div' style={{marginBottom: 20}}><p
                                        style={{textAlign: "left"}}>
                                            <span>
                                            <strong>Medication for Opioid Use Disorder (MOUD): </strong>Take your prescribed medications as directed to manage withdrawal symptoms and reduce cravings.
                                            </span></p>
                                    </ListItem>
                                    <ListItem as='div' style={{marginBottom: 20}}><p
                                        style={{textAlign: "left"}}>
                                            <span>
                                                <strong>Regular Testing:</strong> Get regular health check-ups and screenings for HIV, Hepatitis C, and other infections.
                                            </span>
                                    </p>
                                    </ListItem>
                                    <ListItem as='div' style={{marginBottom: 20}}><p
                                        style={{textAlign: "left"}}>
                                            <span>
                                                <strong>Peer Support:</strong> Connect with others in recovery to share experiences and strategies. Support groups can provide emotional support and practical advice.
                                            </span>
                                    </p>
                                    </ListItem>
                                    <ListItem as='div' style={{marginBottom: 20}}><p
                                        style={{textAlign: "left"}}>
                                            <span>
                                                <strong>Housing:</strong> Seek safe and stable housing situations. Homeless shelters and transitional housing can provide temporary relief and safety.</span>
                                    </p>
                                        <br/>
                                    </ListItem>
                                </List>
                            </GridColumn>
                            <GridColumn width={8} style={{padding: 0}}>
                                <List as='ul'>
                                    <ListItem as='div' style={{marginBottom: 20}}><p
                                        style={{textAlign: "left"}}><span>
                                            <strong>Test your drugs:</strong> Use test strips for Fentanyl or xylazine. They are available from syringe service programs and other programs.
                                        </span></p>
                                    </ListItem>
                                    <ListItem as='div' style={{marginBottom: 20}}><p
                                        style={{textAlign: "left"}}>
                                            <span>
                                            <strong>Safer Smoking:</strong> Safer smoking kits are available from syringe service programs and other programs. Do not share pipes or smoking supplies with others. When smoking, inhale slowly and exhale immediately. Do not hold the smoke in your lungs.
                                            </span></p>
                                    </ListItem>
                                    <ListItem as='div' style={{marginBottom: 20}}><p
                                        style={{textAlign: "left"}}>
                                            <span><strong>Safer Snorting:</strong> Use sterile straws or clean hands for snorting. Avoid using rolled up money, pens, keys or other objects to snort. Rinse your nose before and after snorting and alternate nostrils each time you use.
                                            </span>
                                    </p>
                                    </ListItem>
                                    <ListItem as='div' style={{marginBottom: 20}}><p
                                        style={{textAlign: "left"}}>
                                            <span>
                                                <strong>Safer Alternatives: </strong>Rectal use can be a safer alternative to injection.</span>
                                    </p>
                                    </ListItem>
                                </List>
                            </GridColumn>

                        </Grid>
                    </div>
                    <br/>
                    <div style={{textAlign: "center", marginBottom: 100}}>
                        <span
                            style={{textAlign: "center"}}>
                            Learn more about safer use practices at <a target="_blank"
                                                                       href="SaferSubstanceUse.com">SaferSubstanceUse.com.</a>
                        </span>
                        <br/>
                        <span
                            style={{textAlign: "center"}}>
                                Visit the <strong>CHCV Syringe Services Program</strong> at 270 Congress Avenue on Monday, Wednesday and Friday from 9 am to 12 pm and 1 pm to 4 pm or call <a
                            href="tel:2038230743">(203) 823-0743</a> for mobile clinic dates and locations.
                            </span>
                    </div>
                </div>
            </Container>
            <footer>
                <p>
                    <span className={"header"}>This project was developed by Love Local Design and Yale School of Medicine
                        for the National Institute on Drug Abuse</span>
                    <br/>
                    <br/>
                    <span className={"subheader"}>This project was developed as part of the ADAPT study funded by the
                        National Institute for Drug Abuse (NIDA) to help
                        doctors use better ways to treat patients with opioid addiction in the emergency department.
                        The study looks at how doctors use special tools to start treatment for opioid addiction,
                        but it won’t collect any personal information like your name or phone number.
                        If you don’t want to be part of the study, you can call 203-737-2810 to opt out.
                        ADAPT: Adaptive Decision support for Addiction Treatment; (IRB Yale HIC Protocol Number:
                        2000038624).</span>
                </p>
            </footer>
        </React.Fragment>
    );
};

export default withRouter(ClinicianForm);
